module.exports = __webpack_public_path__ + "static/media/samlogo.78365b1c.png";